import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row, Form } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import Download from '../../MainSection/Download/Download';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import BinMasterTable from './BinMasterTable';
import AddBinMaster from './AddBinMaster';
import BinMasterBulkUploadModal from './BinMasterBulkUploadModal';
import ViewBinMasterModal from './ViewBinMasterModal';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { downloadBinMasterDatas, loadBinMasterDatas, loadSingleBinMasterDatas } from '../../../redux/action';
import BinMasterColumnFilterModal from './BinMasterColumnFilterModal';
import searchIcon from '../../../assets/images/Dashboard/search-icon.svg'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, HeadingLevel } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';

const BinMaster = () => {

    let dispatch = useDispatch();
    let location = useLocation();
    const { getBinMasterData, totalDataCount, getSinleBinMasterData, downloadBinMasterData } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const [selectedColumns, setSelectedColumns] = useState([
        "BIN CODE", "BAR CODE ID", "LENGTH", "WIDTH", "HEIGHT",
        "VOLUME", "DIMENSION", "UNIT", "PLANT", "SLOC", "ZONE NAME", "STATUS", "ACTION"
    ]);
    const [binID, setBinID] = useState("");

    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [excelDownloadRequested, setExcelDownloadRequested] = useState(false);
    const [pdfDownloadRequested, setPdfDownloadRequested] = useState(false);
    const [wordDownloadRequested, setWordDownloadRequested] = useState(false);
    const [printDownloadRequested, setPrintDownloadRequested] = useState(false);
    const [imageDownloadRequested, setImageDownloadRequested] = useState(false);

    // Add a new state for downloading
    const [isDownloading, setIsDownloading] = useState(false);

    const binMasterData = () => {
        dispatch(loadBinMasterDatas(setLoading, rowsPerPage, page + 1, searchQuery));
    }
    useEffect(() => {
        binMasterData();
    }, [page, rowsPerPage, searchQuery]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    const handleOpenModal = (binId) => {
        setIsModalOpen(true);
        if (binId) {
            dispatch(loadSingleBinMasterDatas(binId));
            setBinID(binId);
        } else {
            setBinID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };

    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = (binId) => {
        setShowViewDetails(!showViewDetails);
        if (binId) {
            dispatch(loadSingleBinMasterDatas(binId));
            setBinID(binId);
        } else {
            setBinID("");
        }
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        setIsDownloading(true);
        setExcelDownloadRequested(true);
        dispatch(downloadBinMasterDatas(searchQuery, setIsDownloading));
    };

    useEffect(() => {
        if (excelDownloadRequested && downloadBinMasterData && downloadBinMasterData.length > 0) {
            const dataToExport = downloadBinMasterData.map(item => ({
                "BIN CODE": item.BinCode || "NA",
                "BAR CODE ID": item.BarCodeID || "NA",
                "LENGTH": item.Length || "NA",
                "WIDTH": item.Width || "NA",
                "HEIGHT": item.Height || "NA",
                "VOLUME": item.Volume || "NA",
                "DIMENSION": item.Dimension || "NA",
                "UNIT": item.UOMCode || "NA",
                "PLANT": item.PlantName || "NA",
                "SLOC": item.SlocName || "NA",
                "ZONE NAME": item.ZoneName || "NA",
                "STATUS": item.Status || "NA",
            }));

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(dataToExport);

            // Calculate column widths
            const columnWidths = Object.keys(dataToExport[0]).map((key, colIndex) => {
                const maxLength = Math.max(
                    key.length,
                    ...dataToExport.map(row => (row[key] ? row[key].toString().length : 0))
                );
                return { wch: maxLength + 5 }; // Add padding
            });

            ws['!cols'] = columnWidths; // Set column widths

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "BinMaster");

            // Download
            XLSX.writeFile(wb, 'bin_master.xlsx');
            // Reset flag after download
            setExcelDownloadRequested(false); // ✅ So it doesn’t re-trigger
        }
    }, [excelDownloadRequested, downloadBinMasterData]);

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        setIsDownloading(true);
        setPdfDownloadRequested(true);
        dispatch(downloadBinMasterDatas(searchQuery, setIsDownloading));
    };

    useEffect(() => {
        if (pdfDownloadRequested && downloadBinMasterData && downloadBinMasterData.length > 0) {
            const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

            // Title
            doc.setFontSize(18);
            doc.text("Bin Master Data", 14, 20);

            const dataToExport = downloadBinMasterData?.map(item => ([
                item.BinCode || "NA",
                item.BarCodeID || "NA",
                item.Length || "NA",
                item.Width || "NA",
                item.Height || "NA",
                item.Volume || "NA",
                item.Dimension || "NA",
                item.UOMCode || "NA",
                item.PlantName || "NA",
                item.SlocName || "NA",
                item.ZoneName || "NA",
                item.Status || "NA",
            ])) || [];

            const columns = [
                { title: "BIN CODE", dataKey: "BinCode" },
                { title: "BAR CODE ID", dataKey: "BarCodeID" },
                { title: "LENGTH", dataKey: "LENGTH" },
                { title: "WIDTH", dataKey: "Width" },
                { title: "HEIGHT", dataKey: "Height" },
                { title: "VOLUME", dataKey: "Volume" },
                { title: "DIMENSION", dataKey: "Dimension" },
                { title: "UNIT", dataKey: "UOMCode" },
                { title: "PLANT", dataKey: "PlantName" },
                { title: "SLOC", dataKey: "SlocName" },
                { title: "ZONE NAME", dataKey: "ZoneName" },
                { title: "STATUS", dataKey: "Status" },
            ];

            // Generate table
            doc.autoTable({
                head: [columns],
                body: dataToExport,
                startY: 30,
                tableWidth: 'auto', // Auto-adjust table to fit page
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                },
                headStyles: {
                    fillColor: [22, 160, 133],
                    textColor: [255, 255, 255],
                    halign: 'start',
                },
            });

            // Save PDF
            doc.save('activity_log.pdf');
            // Reset flag after download
            setPdfDownloadRequested(false); // ✅ So it doesn’t re-trigger
        }
    }, [pdfDownloadRequested, downloadBinMasterData]);

    const handleDownloadWord = () => {
        setIsDownloading(true);
        setWordDownloadRequested(true);
        dispatch(downloadBinMasterDatas(searchQuery, setIsDownloading));
    };

    useEffect(() => {
        if (wordDownloadRequested && downloadBinMasterData && downloadBinMasterData.length > 0) {
            const dataToExport = downloadBinMasterData.map(item => [
                String(item?.BinCode || "NA"),
                String(item?.BarCodeID || "NA"),
                String(item?.Length || "NA"),
                String(item?.Width || "NA"),
                String(item?.Height || "NA"),
                String(item?.Volume || "NA"),
                String(item?.Dimension || "NA"),
                String(item?.UOMCode || "NA"),
                String(item?.PlantName || "NA"),
                String(item?.SlocName || "NA"),
                String(item?.ZoneName || "NA"),
                String(item?.Status || "NA"),
            ]);

            const headers = ["BIN CODE", "BAR CODE ID", "LENGTH", "WIDTH", "HEIGHT", "VOLUME", "DIMENSION", "UNIT", "PLANT", "SLOC", "ZONE NAME", "STATUS"];

            const tableRows = [
                new TableRow({
                    children: headers.map(header =>
                        new TableCell({
                            children: [new Paragraph({ text: header, bold: true })],
                        })
                    ),
                }),
                ...dataToExport.map(row =>
                    new TableRow({
                        children: row.map(cell =>
                            new TableCell({
                                children: [new Paragraph(cell)],
                            })
                        ),
                    })
                ),
            ];

            // ✅ Declare `table` BEFORE using it in `sections`
            const table = new Table({
                rows: tableRows,
            });

            const doc = new Document({
                sections: [
                    {
                        properties: {},
                        children: [
                            new Paragraph({
                                text: "Bin Master Report",
                                heading: HeadingLevel.HEADING_1,
                            }),
                            table, // Now this is defined correctly
                        ],
                    },
                ],
            });

            Packer.toBlob(doc)
                .then(blob => saveAs(blob, "bin_Master.docx"))
                .catch(error => {
                    console.error("Error generating Word document:", error);
                    alert("An error occurred while generating the Word document.");
                })
                .finally(() => {
                    setWordDownloadRequested(false);
                });
        } else if (wordDownloadRequested && (!downloadBinMasterData || downloadBinMasterData.length === 0)) {
            alert("No data to export!");
            setWordDownloadRequested(false);
        }
    }, [wordDownloadRequested, downloadBinMasterData]);

    const handlePrint = () => {
        setIsDownloading(true);
        setPrintDownloadRequested(true);
        dispatch(downloadBinMasterDatas(searchQuery, setIsDownloading));
    };

    useEffect(() => {
        if (printDownloadRequested && downloadBinMasterData && downloadBinMasterData.length > 0) {
            if (!downloadBinMasterData || downloadBinMasterData.length === 0) {
                console.error("No data available for printing.");
                alert("No data to print!");
                setPrintDownloadRequested(false);
                return;
            }

            const dataToExport = downloadBinMasterData.map(item => [
                item.BinCode || "NA",
                item.BarCodeID || "NA",
                item.Length || "NA",
                item.Width || "NA",
                item.Height || "NA",
                item.Volume || "NA",
                item.Dimension || "NA",
                item.UOMCode || "NA",
                item.PlantName || "NA",
                item.SlocName || "NA",
                item.ZoneName || "NA",
                item.Status || "NA",
            ]);

            const headers = ["BIN CODE", "BAR CODE ID", "LENGTH", "WIDTH", "HEIGHT", "VOLUME", "DIMENSION", "UNIT", "PLANT", "SLOC", "ZONE NAME", "STATUS"];

            const tableHtml = `
          <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
            <thead>
              <tr>
                ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${dataToExport.map(row => `
                <tr>
                  ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        `;

            const printWindow = window.open('', '', 'width=800,height=600');
            printWindow.document.write('<html><head><title>Bin Master Report</title>');
            printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write('<h1>Bin Master Report</h1>');
            printWindow.document.write(tableHtml);
            printWindow.document.write('</body></html>');
            printWindow.document.close();

            // Wait for content to load before printing
            printWindow.onload = () => {
                printWindow.focus();
                printWindow.print();
                printWindow.close();
                setPrintDownloadRequested(false);
            };
        }
    }, [printDownloadRequested, downloadBinMasterData]);

    const handleDownloadImage = () => {
        setIsDownloading(true);
        setImageDownloadRequested(true);
        dispatch(downloadBinMasterDatas(searchQuery, setIsDownloading));
    };

    useEffect(() => {
        if (imageDownloadRequested) {
            if (!downloadBinMasterData || downloadBinMasterData.length === 0) {
                console.error("No data available for exporting.");
                alert("No data to export!");
                return;
            }

            const headers = ["BIN CODE", "BAR CODE ID", "LENGTH", "WIDTH", "HEIGHT", "VOLUME", "DIMENSION", "UNIT", "PLANT", "SLOC", "ZONE NAME", "STATUS"];
            const chunkSize = 50; // You can increase/decrease this
            const chunks = [];

            for (let i = 0; i < downloadBinMasterData.length; i += chunkSize) {
                chunks.push(downloadBinMasterData.slice(i, i + chunkSize));
            }

            let currentChunk = 0;

            const processNextChunk = () => {
                if (currentChunk >= chunks.length) return;

                const dataToExport = chunks[currentChunk].map(item => [
                    item.BinCode || "NA",
                    item.BarCodeID || "NA",
                    item.Length || "NA",
                    item.Width || "NA",
                    item.Height || "NA",
                    item.Volume || "NA",
                    item.Dimension || "NA",
                    item.UOMCode || "NA",
                    item.PlantName || "NA",
                    item.SlocName || "NA",
                    item.ZoneName || "NA",
                    item.Status || "NA",
                ]);

                const printContainer = document.createElement("div");
                printContainer.style.position = "absolute";
                printContainer.style.left = "-9999px";
                printContainer.style.backgroundColor = "#fff";
                printContainer.style.padding = "20px";
                printContainer.style.border = "1px solid #ccc";
                printContainer.style.fontFamily = "Arial, sans-serif";
                printContainer.style.width = "1000px";

                printContainer.innerHTML = `
                    <h2 style="text-align: center;">Bin Master Report (Page ${currentChunk + 1})</h2>
                    <table border="1" style="border-collapse: collapse; width: 100%; table-layout: fixed; word-wrap: break-word;">
                        <thead>
                            <tr>
                                ${headers.map(header => `<th style="padding: 10px; background-color: #f2f2f2;">${header}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${dataToExport.map(row => `
                                <tr>
                                    ${row.map(cell => `<td style="padding: 10px;">${cell}</td>`).join('')}
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                `;

                document.body.appendChild(printContainer);

                setTimeout(() => {
                    html2canvas(printContainer, {
                        scale: 1.5,
                        useCORS: true,
                        backgroundColor: "#fff",
                    }).then(canvas => {
                        document.body.removeChild(printContainer);
                        canvas.toBlob(blob => {
                            if (!blob) {
                                console.error("Image generation failed.");
                                alert("Failed to generate image.");
                                return;
                            }

                            const link = document.createElement("a");
                            link.href = URL.createObjectURL(blob);
                            link.download = `bin_master_report_page_${currentChunk + 1}.png`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            currentChunk++;
                            processNextChunk(); // Process next chunk
                        }, "image/png");
                    }).catch(err => {
                        console.error("Error capturing image:", err);
                        alert("Error generating image. Try again.");
                        document.body.removeChild(printContainer);
                    });
                }, 500);
            };

            processNextChunk();
        }
    }, [imageDownloadRequested, downloadBinMasterData]);

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        binMasterData();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Location Master"
                        showDownloadDropdown={true}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Bin Master</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div>
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* {moduleData?.CanCreate === true && */}
                                <SbDropdownButton
                                    pageName="Bin Master"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                                {/* } */}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <BinMasterTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                                getBinMasterData={getBinMasterData}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                                selectedColumns={selectedColumns}
                                isDownloading={isDownloading}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddBinMaster
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    binID={binID}
                    getSinleBinMasterData={getSinleBinMasterData}
                    binMasterData={binMasterData}
                />
            }
            {
                showBulkUploadModal && <BinMasterBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {showColumnFilterModal && (
                <BinMasterColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {/* {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewBinMasterModal
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                    getSinleBinMasterData={getSinleBinMasterData}
                />
            )}
        </div >
    );
};

export default BinMaster;